import { PureComponent } from 'react';
import { Icon } from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import { map, take, size } from '../utils/lodash';
import './styles.scss';

export class SeeMore extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      toggle: true,
    };
  }

  render() {
    const {
      minCount,
      CustomComponent,
      dataSet,
      isView,
      isShowAll = false,
      rest = null,
      t,
    } = this.props;

    return (
      <div>
        {map(
          take(dataSet, this.state.toggle ? minCount : size(dataSet)),
          (group, i) => (
            <CustomComponent key={i} item={group} rest={rest} />
          )
        )}
        <div
          className="see-more-see-less-toggle"
          onClick={() => this.setState({ toggle: !this.state.toggle })}
        >
          {this.state.toggle ? (
            <div className="view-more-btn">
              {' '}
              {isView
                ? t('toggle.view_more')
                : isShowAll
                  ? t('toggle.show_all')
                  : t('toggle.see_more')}
              <Icon className="ml-1" name="chevron down" />
            </div>
          ) : (
            <div className="view-more-btn">
              {' '}
              {isView
                ? t('toggle.view_less')
                : isShowAll
                  ? t('toggle.show_less')
                  : t('toggle.see_less')}
              <Icon className="ml-1" name="chevron up" />
            </div>
          )}
        </div>
      </div>
    );
  }
}

export class ViewMoreText extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      toggle: true,
    };
  }

  render() {
    const {
      text,
      length = 100,
      prefix = '',
      separator = '',
      isView = true,
      t,
    } = this.props;
    const { toggle } = this.state;

    const originalText = prefix
      ? prefix.concat(' ', separator, ' ', text)
      : text;

    let minifiedText = originalText;
    if (toggle && originalText.length > length) {
      minifiedText = originalText.substring(0, length) + '...';
    }

    return (
      <div>
        {minifiedText}
        <span
          className="project-partner-minified-txt"
          onClick={() => this.setState({ toggle: !this.state.toggle })}
        >
          {originalText.length > length &&
            (this.state.toggle ? (
              <span>
                {' '}
                {isView ? t('toggle.view_more') : t('toggle.see_more')}
              </span>
            ) : (
              <span>
                {' '}
                {isView ? t('toggle.view_less') : t('toggle.see_less')}
              </span>
            ))}
        </span>
      </div>
    );
  }
}

// Wrap components with withTranslation HOC
SeeMore = withTranslation()(SeeMore);
ViewMoreText = withTranslation()(ViewMoreText);
